import type {
  AudienceSegmentEntry,
  CumulativeBundleSegment,
  CumulativeDomainSegment,
  InventoryBundle,
  InventoryDomain,
} from '@openx/types/gqlTypes';
import type { ConstValues } from '@openx/types/helpers';
import type { AllTableCriteria } from '@openx/types/tableCriteria';
import type { AudienceSegmentSetWithSegments } from './utils/getTilesData';
import type { DealPromptContextType, DealPromptFilters } from './utils/types';

export const promptModes = {
  DEFAULT_MODE: 'default',
  PREVIEW_MODE: 'preview',
  EDIT_MODE: 'edit',
} as const;
export type PromptMode = ConstValues<typeof promptModes>;

export const spendTooltip = 'Aggregate exchange spend in the past 30 days — not buyer-specific.';

export const ViewOptions = {
  MAIN: 'main',
  DETAILS: 'details',
} as const;

export type ViewOption = ConstValues<typeof ViewOptions>;

export type DealPromptState = {
  prompt: string;
  contextType: DealPromptContextType;
  activeViewType: ViewOption;
  mode: PromptMode;
  lastSubmittedPrompt: string;
  lastSubmittedQueries: string[];
  lastSubmittedContextType: DealPromptContextType;
  lastSubmittedFilterCriteria: AllTableCriteria<DealPromptFilters>;
  loading: boolean;
  firstLoadPerformed: boolean;
  requestAborted: boolean;
  selectedTile?: DealPromptTileDetailsPayload | DealPromptTileDetailsPayloadForAudience;
  selectedItems: InventoryDomain[] | InventoryBundle[];
  selectedAudienceItems: AudienceSegmentEntry[];
  hasError: boolean;
  hasDifferentFiltersThanWissp: boolean;
};

export type DealPromptTileDetailsPayload = {
  title: string;
  item: CumulativeDomainSegment | CumulativeBundleSegment | null;
};

export type DealPromptTileDetailsPayloadForAudience = {
  title: string;
  item: AudienceSegmentSetWithSegments | null;
};

export type AudienceExportTypeValue = ConstValues<typeof audienceExportType>;
export const audienceExportType = {
  OA_MATCH: 'oa_match',
  BIDSTREAM: 'bidstream',
  BIDSTREAM_PLUS: 'bidstream_plus',
} as const;

/** Uppercase values returned by audience segment search `tagGroups.operator`. */
export const audienceSegmentTagGroupOperator = {
  AND: 'AND',
  OR: 'OR',
} as const;
export type AudienceSegmentTagGroupOperator = ConstValues<typeof audienceSegmentTagGroupOperator>;
